import InstoreCodeValidator from './InstoreCodeValidator.module';

export * from './InstoreCodeValidatorModuleProps';
export default InstoreCodeValidator;
